<template lang="html">
    <div class="quick-banner">
        <div class="container">
            <header>
                <h1>课件下载</h1>
                <div class="bottom-nav">
                    <div @click="selectGeneralId(1)" class="bottom-type" :class="{active: generalId==1}">
                        <p>小学</p>
                    </div>
                    <div @click="selectGeneralId(2)" class="bottom-type" :class="{active: generalId==2}">
                        <p>初中</p>
                    </div>
                    <div @click="selectGeneralId(3)" class="bottom-type" :class="{active: generalId==3}">
                        <p>高中</p>
                    </div>
                </div>
                <div class="bottom-nav">
                    <div :class="{grade3: generalId==3}">
                        <template v-for="one in gradeList">
                            <div @click="loadList"  class="bottom-type" :class="{active: gradeId==$key}">
                                <p @click="gradeId=$key">{{one}}</p>
                            </div>
                            <br v-if="$key==9">
                        </template>
                    </div>
                </div>
            </header>
        </div>
    </div>
    <div class="container">
        <div v-if="!bookList.list||!bookList.list.length" style="text-align: center;">暂无数据！</div>
        <div class="row" style="margin-top:20px">
            <div v-for="one in bookList.list" class="col-xs-2 ">
                <div class="show-block">
                    <a v-link="'/index/workInfo?id='+one.id">
                        <img :src="one.logo+'?imageView2/0/h/160'" @error="imgError($index)">
                        <div class="float-title">
                            <p>【{{one.versionId}}】{{one.name}}</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                    <h4 class="modal-title" id="myModalLabel">Modal title</h4>
                </div>
                <div class="modal-body">
                    ...
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import M from '../assets/common.js'
    import C from '../assets/config.js'
    export default {
        data: () => ({
            postParam: {},
            host: C.host,
            bookList: {},
            pageOpt: {
                list: {
                    pageNo: 1
                }
            },
            typeName: {},
            gradeId: {},
            generalId: null,
            gradeList: null,
            databanben: []
        }),
        created: function () {
            var self = this;
            M.getAllType("admin", function (data) {
                self.$set('typeName', data);
                self.findbanben();
            })
        },
        methods: {
            //图片加载错误
            imgError: function (index) {
                this.$set('bookList.list[' + index + '].logo',
                    'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
            },
            selectGeneralId: function (id) {
                this.generalId = id;
                this.$set('gradeList',this.showClass(id));

            },
            // 显示对应年纪
            showClass: function (id) {
                const primary = {
                        1: "一年级(上)",
                        10: "一年级(下)",
                        2: "二年级(上)",
                        11: "二年级(下)",
                        3: "三年级(上)",
                        12: "三年级(下)",
                        4: "四年级(上)",
                        13: "四年级(下)",
                        14: "五年级(下)",
                        5: "五年级(上)",
                        6: "六年级(上)",
                        15: "六年级(下)"
                    },
                    junior = {
                        7: "七年级(上)",
                        8: "八年级(上)",
                        9: "九年级(上)",
                        16: "七年级(下)",
                        17: "八年级(下)",
                        18: "九年级(下)",
                    },
                    height = {
                        27: "高三(下)",
                        26: "高三(上)",
                        25: "高二(下)",
                        24: "高二(上)",
                        23: "高一(下)",
                        22: "高一(上)"
                    };
                    let gra=[primary,junior,height]
                    return gra[id-1]


            },

            // 查询课件列表
            loadList: function () {
                let url = this.host + "wuyan/user/book",
                    params = {
                        pageNo: this.pageOpt.pageNo,
                        pageSize: 100,
                        gradeId: this.gradeId
                    },
                    self = this;
                M.load(url, params, function (data) {
                    if (data.code) {
                        /*M.topRightInfoTips({
                            title: data.message
                        })*/
                        data.data = {list: [], pageNo: 1, totalCount: 0};
                    }
                    data.data.list.forEach(function (a) {
                        self.databanben.forEach(function (b) {
                            if (b.id == a.versionId) {
                                a.versionId = b.name;
                            }
                        })
                    })
                    self.$set("bookList", data.data);
                }, 'get');

            },
            findbanben: function () {
                let url = this.host + 'wuyan/admin/version';
                let self = this;
                let postParam = {};
                M.load(url, postParam, function (data) {
                    self.$set('databanben', data.data)
                    self.loadList();
                }, 'get');
            },
        }
    }

</script>
<style scoped>
    /*头部次级导航*/
    
    .quick-banner {
        font-family: 微软雅黑;
        background-attachment: fixed;
        background-color: #3dccac;
        background-image: url(http://qiniu.ludanmall.com/472/shop/cube/Artboard%201_1479995902886.svg);
        /*height: 300px;*/
        padding-top: 50px;
        padding-bottom: 10px;
    }
    
    .quick-banner h1 {
        color: white;
        text-align: center
    }
    
    .bottom-nav {
        border-top: 2px solid white;
        margin-top: 10px
    }
    
    .bottom-type {
        color: white;
        padding: 5px;
        display: inline-block;
        margin: 5px 0;
        width: 14%;
        text-align: center;
        cursor: pointer;
    }
    .bottom-type.active {
        border-top: 2px solid #337ab7;
        margin: 0;
        color: #337ab7;
    }
    .bottom-type p {
        margin: 0;
        font-size: 18px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    
    .row {
        margin: 0;
        padding: 0;
    }
    
    a:hover {
        text-decoration: none;
    }
    
    .show-block {
        position: relative;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.4);
        min-height: 151px;
        margin: 15px 0;
    }
    
    .show-block img {
        height: 160px;
        display: block;
        margin: auto;
    }
    
    .float-title {
        background: rgba(0, 0, 0, 0.8);
        text-decoration: none;
        color: white;
        position: relative;
        width: 100%;
        height: 40px;
        bottom: 0px;
        font-family: 微软雅黑;
        font-size: 12px;
        word-wrap: break-word;
        display: flex;
        align-items: center;
    }
    .float-title p{
        margin: 0;
    }
    .bottom-nav .grade3{
        width: 450px;
    }
    .bottom-nav .grade3 .bottom-type:nth-child(2n+1){
        float: left;
    }
    .bottom-nav .grade3 .bottom-type{
        min-width: 148px;
    }
</style>



// WEBPACK FOOTER //
// workList.vue?23a68543